import React, { useContext, useState } from 'react';
import { Bell, LogOut, Menu, User } from 'lucide-react';
import { AuthContext } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Header({ toggleSidebar }) {

  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const {user,logout}= useContext(AuthContext);
  const navigate= useNavigate();


  return (
    <header className="bg-white shadow-md py-4 px-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <button onClick={toggleSidebar} className="text-gray-500 mr-4 md:hidden">
            <Menu />
          </button>
          {/* <input
            type="text"
            placeholder="Search..."
            className="bg-gray-100 text-gray-800 rounded-full py-2 px-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <Search className="text-gray-500 ml-2" size={20} /> */}
        </div>
        <div className="flex items-center space-x-4 ">
          <Bell className="text-gray-500 cursor-pointer" size={20} />
          <button
            onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
            className="flex items-center focus:outline-none relative"
          >
            <User className="text-gray-500 cursor-pointer" size={20} />
          </button>

          {isUserMenuOpen && (
              <div className="absolute right-5 top-12 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10">
                <div className="px-4 py-2 text-sm text-gray-700">
                  Signed in as<br />
                  <strong>{user?.name || "unnamed user"}</strong>
                </div>
                <button
                  onClick={()=>{logout();navigate("/login")}}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <LogOut className="inline-block mr-2" size={16} />
                  Logout
                </button>
              </div>
            )}

        </div>
      </div>
    </header>
  );
}